import { fromJS } from 'immutable';
import * as actions from '../actions/mra';
import { fetchingState } from '@constants';

const initialStats = {
  modelList: {},
  models: {},
  modelSettings: {},
  analysisModels: {},
  analysisNoiModels: {},
  selectedModelId: '',
  calculateState: '',
};

export default (state = fromJS(initialStats), action) => {
  switch (action.type) {
    case actions.MRA_MODELS_FETCH_START:
      return state.setIn(['modelList', 'state'], fetchingState.FETCHING);
    case actions.MRA_MODELS_FETCH_SUCCESS:
      let newState = state.setIn(['modelList', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['modelList', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case actions.MRA_MODELS_FETCH_ERROR:
      return state.setIn(['modelList', 'state'], fetchingState.ERROR);

    case actions.MRA_MODEL_DELETE_SUCCESS:
      let newModels = state.getIn(['modelList', 'data']).toJS();
      newModels = newModels.filter(model => model.modelID !== action.modelId);
      return state.setIn(['modelList', 'data'], fromJS(newModels));

    case actions.MRA_MODEL_CREATE_START:
      return state.setIn(['models', 'state'], fetchingState.FETCHING);
    case actions.MRA_MODEL_CREATE_SUCCESS:
      newState = state.setIn(['models', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['models', 'data', action.data.results[0].modelID.toString()],
        fromJS(action.data.results[0]),
      );
    case actions.MRA_MODEL_CREATE_ERROR:
      return state.setIn(['models', 'state'], fetchingState.ERROR);

    case actions.MRA_MODEL_FETCH_START:
      return state.setIn(['models', 'state'], fetchingState.FETCHING);
    case actions.MRA_MODEL_FETCH_SUCCESS:
      newState = state.setIn(['models', 'state'], fetchingState.LOADED);
      newState = newState.setIn(
        ['modelSettings', action.data.results[0].modelID.toString()],
        fromJS(action.data.results[0].modelSettings),
      );
      return newState.setIn(
        ['models', 'data', action.data.results[0].modelID.toString()],
        fromJS(action.data.results[0]),
      );
    case actions.MRA_MODEL_FETCH_ERROR:
      return state.setIn(['models', 'state'], fetchingState.ERROR);

    case actions.MRA_ANALYSIS_FETCH_START:
      return state.setIn(['analysisModels', 'state'], fetchingState.FETCHING);
    case actions.MRA_ANALYSIS_FETCH_SUCCESS:
      newState = state.setIn(['analysisModels', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['analysisModels', 'data', action.analysisId.toString()],
        fromJS(action.data.results),
      );
    case actions.MRA_ANALYSIS_FETCH_ERROR:
      return state.setIn(['analysisModels', 'state'], fetchingState.ERROR);

    case actions.MRA_ANALYSIS_NOI_FETCH_START:
      return state.setIn(
        ['analysisNoiModels', 'state'],
        fetchingState.FETCHING,
      );
    case actions.MRA_ANALYSIS_NOI_FETCH_SUCCESS:
      newState = state.setIn(
        ['analysisNoiModels', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['analysisNoiModels', 'data', action.analysisId.toString()],
        fromJS(action.data.results),
      );
    case actions.MRA_ANALYSIS_NOI_FETCH_ERROR:
      return state.setIn(['analysisNoiModels', 'state'], fetchingState.ERROR);

    case actions.MRA_MODEL_CALCULATE_START:
      return state.setIn(['calculateState'], fetchingState.FETCHING);
    case actions.MRA_MODEL_CALCULATE_SUCCESS:
      newState = state.setIn(['calculateState'], fetchingState.LOADED);
      return newState.setIn(
        ['models', 'data', action.data.results[0].modelID.toString()],
        fromJS(action.data.results[0]),
      );
    case actions.MRA_MODEL_CALCULATE_ERROR:
      return state.setIn(['calculateState'], fetchingState.ERROR);

    case actions.MRA_MODEL_SETTING_PERSIST_SUCCESS:
      return state.setIn(
        ['modelSettings', action.data.results[0].modelID.toString()],
        fromJS(action.data.results[0].modelSettings),
      );

    case actions.MRA_MODEL_SELECT:
      return state.setIn(['selectedModelId'], action.data);
    default:
      return state;
  }
};
